import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 2, viewBox: "0 0 13 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.667969 1H12.3346", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinus;
